type DescriptionCellProps = {
  description: string;
};

export const DescriptionCellComponent: React.FC<DescriptionCellProps> = ({
  description,
}) => {
  let finalDescription;

  finalDescription = description.slice(description.lastIndexOf(']') + 1).trim();

  const userId = finalDescription.match(
    /(and\s+)?userId:?\s'([a-f0-9]{24})',?/
  );

  if (userId?.[0]) finalDescription = finalDescription.replace(userId[0], '');

  const file = finalDescription.match(/'[^']*\/file[^']*'/g);

  if (file?.[0]) {
    const fileName = file[0].split('_').slice(2).join(' ');
    finalDescription = finalDescription.replace(file[0], `'${fileName}`);
  }

  return <span>{finalDescription}</span>;
};
